jQuery(function($){
	$postsContainer = $('#single-project-gallery');
	if($postsContainer.length > 0) {
		$visibleItems = $postsContainer.find('.item');
		$loadMoreButton = $postsContainer.next('#load-more-button');
		visiblePostsCount = 3;
		postsShown = visiblePostsCount;

		// Hide more button if there are less than 3 posts
		if ($visibleItems.length <= visiblePostsCount) {
			$loadMoreButton.addClass('hide');
		}
		// Show first 3 posts
		for (var i = 0; i < visiblePostsCount; i++) {
		 	$($visibleItems[i]).removeClass('hide');
		}

		// More button click
		$loadMoreButton.on('click', function(e) {
			if (postsShown < $visibleItems.length) {
				for (i = postsShown; i < postsShown+visiblePostsCount; i++) {
					$($visibleItems[i]).removeClass('hide');
				}
				postsShown += visiblePostsCount;
				
				// Hide more button when posts are over			
				if(postsShown >= $visibleItems.length) {
					$loadMoreButton.addClass('hide');
				}
			}
		});
	}
});